<template>
    <div>
        <div class="md-dialog md-theme-default preview-dialog-container">
            <div class="dialog-title-container">
                <div style="display: flex; flex-grow: 1;"><h4 class="text-primary"><b>{{data.name}}</b></h4></div>
                <div @click="close_preview()" style="cursor: pointer;"><i class="material-icons button-icon">cancel</i></div>
            </div>
            <div style="display: flex; flex-grow: 1;">
                <iframe class="preview-iframe" :src="data.url" frameborder="0"></iframe>
            </div>
        </div>
        <transition name="fade" mode="out-in">
            <div class="md-overlay md-fixed md-dialog-overlay" @click="close_preview()"></div>
        </transition>
    </div>
</template>
<script>
    export default {
        props: {
            data: {
                type: Object
            }
        },
        methods: {
            close_preview() {
                this.$emit('close');
            }
        }
    }
</script>

<style scoped>
    .preview-dialog-container {
        width: 95%;
        max-width: 95%;
        min-width: 95%;
        height: 95%;
        max-height: 95%;
        min-height: 95%;
        padding: 5px 15px 15px 15px;
        border-radius: 6px;
        z-index: 100;
        display: flex; 
        flex-direction: column;
    }
    .dialog-title-container {
        display: flex; 
        flex-direction: row; 
        align-items: center;
    }
    .dialog-content-container {
        display: flex; 
        flex-grow: 1; 
        height: 0;
    }
    .preview-iframe {
        width: 100%;
        border-radius: 6px;
    }
</style>


// WEBPACK FOOTER //
// src/components/Preview.vue